module.exports = __webpack_public_path__ + "img/megaphone.f0143353.png";